// @ts-check

/**
 * @typedef {object} State
 * @property {Object.<string, boolean> | null} flags
 */

const defaultState = () => ({
  flags: null
})

export default {
  namespaced: true,
  state: defaultState(),
  mutations: {
    SET (state, flags) {
      state.flags = flags
    },
    RESET_STATE (state) {
      Object.assign(state, defaultState())
    }
  },
  actions: {
    SET_FLAGS ({ commit }, flags) {
      commit('SET', flags)
    },
    RESET_STATE ({ commit }) {
      commit('RESET_STATE')
    }
  },
  getters: {
    /** @argument {State} state */
    hasFlags: state => !!state.flags,
    featureEnabled:
      (/** @type {State} */ state) => (/** @type {string} */ flag) =>
        !!state.flags && !!state.flags[flag]
  }
}

/** @typedef {RefRT<typeof import('@/store/modules/featureFlags').default.getters>} Getters */
